import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./videoPreview.html";
import { ElementType } from '~/modules/analytics/gtmEventTypes/constants';
import { generateMediaUrl } from '~/modules/utilities/asset_utils';
import { WireI18n } from '../../../modules/stores/i18nStore';
const demoImgPath = '/images/demoVideoBG.png';
const videoImgPath = '/images/videoPlaceholderBG.png';
class VideoPlaceholderImage extends LightningElement {
  constructor(...args) {
    super(...args);
    this.providerLogo = void 0;
    this.variant = void 0;
    this.positionIndex = void 0;
    this.altText = '';
    this.i18n = void 0;
  }
  get containerClass() {
    const baseContainerClass = 'preview__container';
    const fillClass = 'fill';
    return this.variant === 'Video' ? baseContainerClass : `${baseContainerClass} ${fillClass}`;
  }
  get backgroundClass() {
    const baseBackgroundClass = 'preview__background';
    const roundedClass = 'rounded';
    return this.variant === 'Video' ? baseBackgroundClass : `${baseBackgroundClass} ${roundedClass}`;
  }
  get backgroundImage() {
    return this.variant === 'Video' ? videoImgPath : demoImgPath;
  }
  get showNewWindowIcon() {
    return this.variant === 'Demo';
  }
  get displayText() {
    return this.variant === 'Video' ? this.i18n.listingDetails.carousel.watchVideo : this.i18n.listingDetails.carousel.watchDemo;
  }
  get logo() {
    if (this.providerLogo) {
      return generateMediaUrl(this.providerLogo);
    }
    return '';
  }
  get buttonRole() {
    if (this.variant === 'Demo') {
      return 'link';
    }
    return 'button';
  }
  handleAnalytics(event) {
    if (this.variant === 'Demo') {
      event.stopPropagation();
    } else {
      event.detail.image = {
        positionIndex: this.positionIndex
      };
    }
  }
  handleClick() {
    if (this.variant === 'Demo') {
      const selection = new CustomEvent('analytics', {
        bubbles: true,
        composed: true,
        detail: {
          eventType: 'click',
          elementType: ElementType.CAROUSEL,
          lead_type: 'demo'
        }
      });
      this.dispatchEvent(selection);
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(VideoPlaceholderImage, {
  publicProps: {
    providerLogo: {
      config: 0
    },
    variant: {
      config: 0
    },
    positionIndex: {
      config: 0
    },
    altText: {
      config: 0
    }
  },
  wire: {
    i18n: {
      adapter: WireI18n,
      config: function ($cmp) {
        return {};
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(VideoPlaceholderImage, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;